export default "__VITE_ASSET__D2rz43Ox__"